<div class="ui-form-field" [attr.data-appearance]="appearance()">
  @if (label()) {
    <label class="ui-form-field__label" [attr.for]="id() || null">
      {{ label() | uiLabelTranslate }}
      @if (required()) {
        <span class="ui-form-field__required">*</span>
      }
    </label>
  }

  <div class="ui-form-field__control-wrap" [class.ui-form-field__control-wrap--with-suffix]="isPasswordField() || showPlaceholderHint()">
    @if (type() === 'textarea') {
      <textarea
        pTextarea
        class="ui-form-field__control"
        [attr.id]="id() || null"
        [value]="value()"
        [placeholder]="placeholder() | uiLabelTranslate"
        [disabled]="disabled()"
        [readonly]="readonly()"
        [rows]="rows()"
        (input)="onValueChange(fieldValue)"
        [attr.aria-invalid]="!!error()"
        [attr.aria-required]="required()"
        #fieldValue
      ></textarea>
    } @else if (isFileField()) {
      <div
        class="ui-form-field__file-drop"
        [class.ui-form-field__file-drop--drag-over]="dragOver()"
        [class.ui-form-field__file-drop--disabled]="disabled()"
        [class.ui-form-field__file-drop--error]="!!error()"
        (dragover)="onDragOver($event)"
        (dragleave)="onDragLeave()"
        (drop)="onDrop($event)"
        (click)="!disabled() && fileInput.click()"
        [attr.role]="'button'"
        [attr.tabindex]="disabled() ? -1 : 0"
        [attr.aria-label]="fileDropLabel()"
        [attr.aria-disabled]="disabled()"
        (keydown.enter)="!disabled() && fileInput.click()"
        (keydown.space)="!disabled() && fileInput.click()"
      >
        <input
          #fileInput
          type="file"
          class="ui-form-field__file-input"
          [attr.id]="id() || null"
          [attr.accept]="accept() || null"
          [multiple]="multiple()"
          [disabled]="disabled()"
          [attr.aria-required]="required()"
          (change)="onFileInputChange($event)"
        />
        <span class="material-symbols-rounded ui-form-field__file-icon" aria-hidden="true">upload_file</span>
        <span class="ui-form-field__file-label">{{ fileDropLabel() | uiLabelTranslate }}</span>
        @if (maxFileSizeMb()) {
          <span class="ui-form-field__file-size-hint">Max {{ maxFileSizeMb() }} MB</span>
        }
      </div>
      @if (selectedFiles().length) {
        <ul class="ui-form-field__file-list" [attr.aria-label]="'shared.form.selectedFiles' | uiLabelTranslate">
          @for (file of selectedFiles(); track file.name; let i = $index) {
            <li class="ui-form-field__file-item">
              <span class="material-symbols-rounded ui-form-field__file-item-icon" aria-hidden="true">description</span>
              <span class="ui-form-field__file-item-name">{{ file.name }}</span>
              <button
                type="button"
                class="ui-form-field__file-remove"
                [attr.aria-label]="'shared.form.removeFileAction' | uiLabelTranslate"
                [disabled]="disabled()"
                (click)="$event.stopPropagation(); removeFile(i)"
              >
                <span class="material-symbols-rounded" aria-hidden="true">close</span>
              </button>
            </li>
          }
        </ul>
      }
    } @else {
      <input
        pInputText
        class="ui-form-field__control"
        [attr.id]="id() || null"
        [type]="resolvedInputType()"
        [value]="value()"
        [placeholder]="placeholder() | uiLabelTranslate"
        [disabled]="disabled()"
        [readonly]="readonly()"
        [required]="required()"
        [min]="min() || null"
        [max]="max() || null"
        [step]="step() || null"
        (input)="onValueChange(fieldValue)"
        [attr.aria-invalid]="!!error()"
        [attr.aria-required]="required()"
        [attr.inputmode]="type() === 'number' ? 'decimal' : (type() === 'tel' ? 'numeric' : null)"
        [attr.pattern]="type() === 'tel' ? '[0-9]*' : null"
        #fieldValue
      />
    }
    <span class="ui-form-field__suffix">
      @if (showPlaceholderHint()) {
        <button
          type="button"
          class="ui-form-field__info-toggle"
          [pTooltip]="placeholder()"
          tooltipPosition="top"
          [attr.aria-label]="'shared.form.fieldHint' | uiLabelTranslate"
        >
          <span class="material-symbols-rounded" aria-hidden="true">info</span>
        </button>
      }
      @if (isPasswordField()) {
        <button
          type="button"
          class="ui-form-field__password-toggle"
          [attr.aria-label]="passwordToggleLabel() | uiLabelTranslate"
          [attr.aria-pressed]="passwordVisible()"
          [disabled]="disabled()"
          (click)="togglePasswordVisibility()"
        >
          <span class="material-symbols-rounded" aria-hidden="true">{{ passwordToggleIcon() }}</span>
        </button>
      }
      <ng-content select="[uiFieldSuffix]" />
    </span>
  </div>

  @if (error()) {
    <p class="ui-form-field__error">{{ error() | uiLabelTranslate }}</p>
  } @else if (hint()) {
    <p class="ui-form-field__hint">{{ hint() | uiLabelTranslate }}</p>
  }
</div>
